export default "__VITE_ASSET__D0LakGDm__"